// Auto generated file, do not manually modify!
// com.hotpads.listingdatamodeltypes.enums.PropertyType

export enum PropertyType {
  CONDO = 'CONDO',
  DIVIDED = 'DIVIDED',
  GARDEN = 'GARDEN',
  HOUSE = 'HOUSE',
  LAND = 'LAND',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  TOWNHOUSE = 'TOWNHOUSE',
  UNKNOWN = 'UNKNOWN',
}

export const PropertyType_values = [
  PropertyType.CONDO,
  PropertyType.DIVIDED,
  PropertyType.GARDEN,
  PropertyType.HOUSE,
  PropertyType.LAND,
  PropertyType.LARGE,
  PropertyType.MEDIUM,
  PropertyType.TOWNHOUSE,
  PropertyType.UNKNOWN,
] as const;
